import topTitle from '@/views/template/components/title';
export default {
  components: {
    topTitle
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [{
        name: '投保须知'
      }, {
        name: '投保须知'
      }, {
        name: '投保须知'
      }, {
        name: '投保须知'
      }]
    };
  }
};